import { motion } from "framer-motion";
import { Code2, Brain, Rocket, Coffee } from "lucide-react";

const stats = [
  { label: "Years Experience", value: "6+", icon: Coffee },
  { label: "Projects Completed", value: "20+", icon: Rocket },
  { label: "Technologies", value: "10+", icon: Code2 },
  { label: "AI/ML Projects", value: "3", icon: Brain },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-24 px-4 sm:px-6 lg:px-8 relative z-10">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2
            className="text-3xl md:text-5xl font-bold gradient-cyan mb-4"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            About Me
          </h2>
          <p className="text-[#a0a0b0] text-lg max-w-2xl mx-auto">
            A passionate developer building the future with AI
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left - Photo */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative"
          >
            <div className="max-w-md mx-auto relative">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#00d4aa]/30 to-[#6ee7c2]/20 rounded-3xl blur-2xl" />

              {/* Photo container */}
              <div className="relative bg-[#16161f] border border-[#252530] rounded-3xl p-6 overflow-hidden">
                <img
                  src="/images/chethan.jpg"
                  alt="Chethan"
                  className="w-full aspect-square object-cover rounded-2xl"
                />
                <div className="mt-4 text-center">
                  <h3
                    className="text-2xl font-bold text-[#f0f0f5] mb-1"
                    style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
                  >
                    Chethan
                  </h3>
                  <p className="text-[#00d4aa] font-medium">
                    Full Stack AI Product Engineer
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right - Bio */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="space-y-6"
          >
            <p className="text-[#a0a0b0] text-lg leading-relaxed">
              I'm a Full Stack AI Product Engineer focused on building
              intelligent, user-centered products that solve real-world
              problems. I'm currently learning Machine Learning to deepen my
              expertise in model development and deployment.
            </p>
            <p className="text-[#a0a0b0] text-lg leading-relaxed">
              My journey in tech started with a curiosity about how things work,
              and has evolved into a career focused on pushing the boundaries of
              what's possible with code. I specialize in React, Python, and
              building AI-powered applications.
            </p>
            <p className="text-[#a0a0b0] text-lg leading-relaxed">
              This portfolio itself is a demonstration of my skills - powered by
              Retrieval-Augmented Generation (RAG), it can answer questions
              about my work and experience intelligently.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4 pt-6">
              {stats.map((stat, index) => (
                <motion.div
                  key={stat.label}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.4 + index * 0.1 }}
                  className="bg-[#16161f] border border-[#252530] rounded-xl p-4 hover:border-[#00d4aa]/30 transition-colors"
                >
                  <stat.icon className="w-5 h-5 text-[#00d4aa] mb-2" />
                  <div className="text-2xl font-bold text-[#f0f0f5]">
                    {stat.value}
                  </div>
                  <div className="text-sm text-[#606070]">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
